import defaultLayoutComponent from '~pages/layouts/DefaultLayoutComponents.js'
import AbstractLayout from '~pages/layouts/AbstractLayout.vue'
let routeInfo = [
  {
    path: 'course',
    name: 'Course',
    components: Object.assign({}, defaultLayoutComponent, { content: AbstractLayout }),
    beforeEnter: (to, from, next) => {
      console.log('cart root beforeEnter', to, from)
      next()
    },
    meta: {
      authorized: true
    },
    children: [
      {
        path: 'detail/:pCorsCd',
        name: 'CourseDetail',
        component: () => import(/* webpackChunkName: "page_member" */ '~pages/contents/course/CourseDetail.vue'),
        beforeEnter: (to, from, next) => {
          console.log('## CourseDetail:::', to, from)
          next()
        },
        meta: {
          authorized: false
        },
        props: true
      },
      {
        path: 'crsDetail',
        name: 'CrsDetail',
        component: () => import(/* webpackChunkName: "page_payment" */ '~pages/contents/course/CourseDetail.vue'),
        beforeEnter: (to, from, next) => {
          console.log('## CourseDetail:', to, from)
          next()
        },
        meta: {
          authorized: false
        }
      }
    ]
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/child/course.js